import {
  SAVE_ITEM_FAILURE,
  SAVE_ITEM_SUCCESS,
  SAVE_ITEM_REQUEST,
  FETCH_ITEMS_REQUEST,
  FETCH_ITEMS_SUCCESS,
  FETCH_ITEMS_FAILURE,
  DELETE_ITEM_REQUEST,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAILURE,
  FETCH_ITEM_REQUEST,
  FETCH_ITEM_SUCCESS,
  FETCH_ITEM_FAILURE,
  FETCH_ITEM_IMAGE_REQUEST,
  FETCH_ITEM_IMAGE_SUCCESS,
  FETCH_ITEM_IMAGE_FAILURE,
  FETCH_ITEM_COMPLETE_REQUEST,
  FETCH_ITEM_COMPLETE_SUCCESS,
  FETCH_ITEM_COMPLETE_FAILURE,
  FETCH_SIMPLE_ITEM_LIST_PDF_REQUEST,
  FETCH_SIMPLE_ITEM_LIST_PDF_SUCCESS,
  FETCH_SIMPLE_ITEM_LIST_PDF_FAILURE,
  FETCH_CUSTOM_ITEM_LIST_PDF_REQUEST,
  FETCH_CUSTOM_ITEM_LIST_PDF_SUCCESS,
  FETCH_CUSTOM_ITEM_LIST_PDF_FAILURE,
} from './types';

const INITIAL_STATE = {
  items: [],
  item: null,
  itemComplete: null,
  itemImageUrl: '',
  loading: false,
  error: null,
  simpleItemList: null,
  simpleItemListLoading: false,
  customItemList: null,
  customItemListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ITEMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };

    case FETCH_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: [],
      };
    case SAVE_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.payload,
      };

    case FETCH_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        item: null,
      };
    case FETCH_ITEM_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ITEM_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        itemImageUrl: action.payload,
      };

    case FETCH_ITEM_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        itemImageUrl: '',
      };
    case FETCH_ITEM_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ITEM_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        itemComplete: action.payload,
      };

    case FETCH_ITEM_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        itemComplete: null,
      };
    case FETCH_SIMPLE_ITEM_LIST_PDF_REQUEST:
      return {
        ...state,
        simpleItemListLoading: true,
        error: null,
      };

    case FETCH_SIMPLE_ITEM_LIST_PDF_SUCCESS:
      return {
        ...state,
        simpleItemListLoading: false,
        simpleItemList: action.payload,
      };

    case FETCH_SIMPLE_ITEM_LIST_PDF_FAILURE:
      return {
        ...state,
        simpleItemListLoading: false,
        error: action.payload.error,
        simpleItemList: null,
      };

    case FETCH_CUSTOM_ITEM_LIST_PDF_REQUEST:
      return {
        ...state,
        customItemListLoading: true,
        error: null,
      };

    case FETCH_CUSTOM_ITEM_LIST_PDF_SUCCESS:
      return {
        ...state,
        customItemListLoading: false,
        customItemList: action.payload,
      };

    case FETCH_CUSTOM_ITEM_LIST_PDF_FAILURE:
      return {
        ...state,
        customItemListLoading: false,
        error: action.payload.error,
        customItemList: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
